export default () => ({
  trigger: {
    name: 'add_to_cart_page.select_continue_shopping',
    params: {},
  },
  config: {
    event: {
      name: 'select_content',
      params: {
        sub_feature: null,
        content: 'continue_shopping',
      },
    },
  },
});
